<template>
  <div class="">
    <div class="mb-6">
      <SegmentSelector v-model="segment" />
    </div>
    <div class="relative mb-8 overflow-hidden">
      <DonutChart
        :data="pieData"
        :show-labels="question !== 9"
        class="w-60 h-60 mx-auto"
      />

      <div v-if="question === 9" class="mt-4 md:mt-0 md:absolute top-0 right-0">
        <div
          v-for="item in pieData"
          :key="item.name"
          class="text-xs font-bold flex items-start mb-2"
        >
          <font-awesome-icon
            :icon="['fas', 'square']"
            :style="{ color: item.color }"
            class="mr-2 text-base"
          />
          <div class="md:w-44">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div class="mb-4">{{ subquestionText }}</div>

    <HorizontalBarChart bar-class="bg-secondaryYellow" :data="barData1" />
  </div>
</template>

<script>
import DonutChart from "@/components/DonutChart";
import HorizontalBarChart from "@/components/HorizontalBarChart";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import SegmentSelector from "@/components/SegmentSelector";
import colors from "@/utils/colors";

export default {
  components: {
    DonutChart,
    HorizontalBarChart,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: data[this.question]
        .filter((e) => e[IDS.QUESTION_SUBNUMBER] === "")
        // remove NS/NC for all questions except 8 and 9
        .filter(
          (e) => [8, 9].includes(this.question) || e[IDS.ANSWER] !== IDS.NSNC
        ),
      subquestion1: data[this.question].filter(
        (e) => e[IDS.QUESTION_SUBNUMBER] === "a"
      ),
      subquestionText: data[this.question].find(
        (e) => e[IDS.QUESTION_SUBNUMBER] === "a"
      )[IDS.QUESTION_MAIN],

      segment: "TOTAL",
    };
  },
  computed: {
    pieData() {
      const pieColors = {
        [IDS.SI]: colors.secondaryYellow,
        [IDS.NO]: colors.tertiary,
        [IDS.NSNC]: colors.nsnc,
        [IDS.AFECTA_MAS]: colors.secondaryYellow,
        [IDS.TODAS_PERSONAS_POSIBILIDADES]: colors.tertiary,
      };

      return this.data
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          color: pieColors[e[IDS.ANSWER]],
          textColor: [IDS.SI, IDS.AFECTA_MAS].includes(e[IDS.ANSWER])
            ? "#000000"
            : "#ffffff",
        }))
        .sort((a, b) => (b.name === IDS.SI ? 1 : -1));
    },
    barData1() {
      return this.subquestion1
        .map((e) => ({
          name: e[IDS.ANSWER],
          value: e[IDS[this.segment]],
          compare: null,
        }))
        .sort((a, b) => b.value - a.value);
    },
  },
};
</script>

<style></style>
